export default __webpack_public_path__ + "static/media/trash-can-delete-icon.3270f2c9.svg";